// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SecureMessagingSend-module__container___yWc2q {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.SecureMessagingSend-module__title___FJ6QR {
  color: #375844;
}

.SecureMessagingSend-module__button___lD_N7 {
  width: auto;
  align-self: flex-start;
}`, "",{"version":3,"sources":["webpack://./src/pages/PatientDetails/fragments/SecureMessagingSend/SecureMessagingSend.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,WAAA;EACA,sBAAA;AACF","sourcesContent":[".container {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.title {\n  color: #375844;\n}\n\n.button {\n  width: auto;\n  align-self: flex-start;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SecureMessagingSend-module__container___yWc2q`,
	"title": `SecureMessagingSend-module__title___FJ6QR`,
	"button": `SecureMessagingSend-module__button___lD_N7`
};
module.exports = ___CSS_LOADER_EXPORT___;
